import {ReactComponent as DividerHorizontalInternal} from './bg-horizontal.svg';
function DividerHorizontal({ num }) {
  return (
    <div className={`Divider-horizontal Divider-horizontal-${num}`}>
      <DividerHorizontalInternal className="Divider-horizontal-internal"/>
    </div>
  )
}

export default DividerHorizontal